import { useQuery } from "@tanstack/react-query";
import http from "../services/http-common";

export const usePrivateInsuranceEphemeralUrl = (leaseId: string) => {
  const query = useQuery({
    queryKey: ["leasePrivateInsuranceEphemeralUrl", leaseId],
    queryFn: async () => {
      const { data } = await http.get<{ url: string }>(`/leases/private-insurance-ephemeral-url/${leaseId}`);
      return data.url;
    },
    enabled: false, // manual: only fetch via refetch()
    staleTime: 0, // always stale
    cacheTime: 0, // don't cache
    refetchOnMount: false,
    refetchOnWindowFocus: false, // no auto-refetch on focus
    retry: false,
  });

  return query;
};
